@if (control(); as control) {
  @if (field(); as field) {
    <div fxFlex fxLayout="column" fxLayoutGap="10px">
      <iot-platform-ui-checkbox-group
        fxFlex
        class="iot-platform-ui-form-field--{{ field.name?.() }} {{ field.inputCssClassName?.() }}"
        data-cy="form-control"
        [formControl]="control"
        [items]="field.items?.() ?? []"
        [displayBy]="field.displayBy"
        [selectBy]="field.selectBy"
        [required]="required()"
        [capitalized]="$safeNavigationMigration(field.capitalized?.())"
        [disabled]="$safeNavigationMigration(field.disabled?.())"
        [isOptionDisabled]="field.isOptionDisabled"
        [fxFlexOption]="$safeNavigationMigration(field.fxFlexOption?.())"
        (selectionChange)="field.selectionChange?.($event)"
      />

      @if (control?.touched && control?.invalid && control?.hasError('required')) {
        <mat-error class="fs-8">{{ 'FORM.ERROR_MESSAGE.REQUIRED' | translate }}</mat-error>
      } @else if (control?.touched && control?.invalid && field.error?.enabled?.() && field.error?.message?.()) {
        <mat-error class="fs-8">{{ $safeNavigationMigration(field.error?.message?.()) | translate }}</mat-error>
      }
    </div>
  }
}
